import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
import UserManagement from '../views/UserManagement.vue';
import VoyageBinding from '../views/VoyageBinding.vue';
import PassageRecord from '../views/PassageRecord.vue';
import DataStatistics from '../views/DataStatistics.vue';
import VideoPreview from '../views/VideoPreview.vue';
import FenceAlarm from '../views/FenceAlarm.vue';
import DeviceManagement from '../views/DeviceManagement.vue'; // 导入设备管理组件
import CameraManagement from '../views/CameraManagement.vue'; // 导入摄像头管理组件
import NoPermission from '../views/NoPermission.vue';
import PermissionManagementPage from '../views/PermissionManagementPage.vue';
import VehicleDeparture from '../views/VehicleDeparture.vue';
import AccessRegistrationHome from '../views/AccessRegistrationHome.vue';
import AccessRegistrationPersonIn from '../views/AccessRegistrationPersonIn.vue';
import AccessRegistrationForm from '../views/AccessRegistrationForm.vue';
import AccessRecords from '../views/AccessRecords.vue';
import { getPublicPaths } from '../constants/pagePermissions';
import { hasRoutePermission, resolveDefaultAuthorizedPath } from '../utils/permission';

Vue.use(VueRouter);

const PUBLIC_PATHS = new Set(getPublicPaths());

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'user-management',
        name: 'UserManagement',
        component: UserManagement
      },
      {
        path: 'voyage-binding',
        name: 'VoyageBinding',
        component: VoyageBinding
      },
      {
        path: 'passage-record',
        name: 'PassageRecord',
        component: PassageRecord
      },
      {
        path: 'data-statistics',
        name: 'DataStatistics',
        component: DataStatistics
      },
      {
        path: 'access-records',
        name: 'AccessRecords',
        component: AccessRecords
      },
      {
        path: 'fence-alarm',
        name: 'FenceAlarm',
        component: FenceAlarm
      },
      {
        path: 'device-management',
        name: 'device-management',
        component: DeviceManagement
      },
      {
        path: 'camera-management/:deviceId?',
        name: 'CameraManagement',
        component: CameraManagement,
        props: true
      },
      {
        path: 'video-preview/:deviceId?',
        name: 'VideoPreview',
        component: VideoPreview,
        props: true
      },
      {
        path: 'live-test',
        name: 'live-test',
        component: () => import('@/views/LiveTest.vue')
      },
      {
        path: 'permanent-personnel',
        name: 'PermanentPersonnel',
        component: () => import('@/views/PermanentPersonnel.vue')
      },
      {
        path: 'domestic-crew',
        name: 'DomesticCrew',
        component: () => import('@/views/DomesticCrew.vue')
      },
      {
        path: 'vehicle-departure',
        name: 'VehicleDeparture',
        component: VehicleDeparture
      },
      {
        path: 'access-registration',
        name: 'AccessRegistrationHome',
        component: AccessRegistrationHome
      },
      {
        path: 'access-registration/person-in',
        name: 'AccessRegistrationPersonIn',
        component: AccessRegistrationPersonIn
      },
      {
        path: 'access-registration/person-out',
        name: 'AccessRegistrationPersonOut',
        component: AccessRegistrationForm,
        props: { moduleType: 'person_out' }
      },
      {
        path: 'access-registration/vehicle-in',
        name: 'AccessRegistrationVehicleIn',
        component: AccessRegistrationForm,
        props: { moduleType: 'vehicle_in' }
      },
      {
        path: 'access-registration/vehicle-out',
        name: 'AccessRegistrationVehicleOut',
        component: AccessRegistrationForm,
        props: { moduleType: 'vehicle_out' }
      },
      {
        path: 'access-registration/crew-luggage-in',
        name: 'AccessRegistrationCrewLuggageIn',
        component: AccessRegistrationForm,
        props: { moduleType: 'crew_luggage_in' }
      },
      {
        path: 'access-registration/crew-luggage-out',
        name: 'AccessRegistrationCrewLuggageOut',
        component: AccessRegistrationForm,
        props: { moduleType: 'crew_luggage_out' }
      },
      {
        path: 'access-registration/crew-no-luggage-in',
        name: 'AccessRegistrationCrewNoLuggageIn',
        component: AccessRegistrationForm,
        props: { moduleType: 'crew_no_luggage_in' }
      },
      {
        path: 'access-registration/crew-no-luggage-out',
        name: 'AccessRegistrationCrewNoLuggageOut',
        component: AccessRegistrationForm,
        props: { moduleType: 'crew_no_luggage_out' }
      },
      {
        path: 'permission-management',
        name: 'PermissionManagement',
        component: PermissionManagementPage
      },
      {
        path: 'no-permission',
        name: 'NoPermission',
        component: NoPermission
      },
      {
        path: '/home/user-edit/:userId',
        name: 'UserEdit',
        component: () => import('@/views/UserEdit.vue'),
        props: route => ({
          userId: route.params.userId,
          userData: route.params.userData
        })
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = !!localStorage.getItem('token');
  const isPublicPath = PUBLIC_PATHS.has(to.path);

  if (isPublicPath) {
    next();
    return;
  }

  if (to.path !== '/login' && !isLogin) {
    next('/login');
  } else if (to.path === '/login' && isLogin) {
    next(resolveDefaultAuthorizedPath());
  } else {
    if (!isLogin) {
      next();
      return;
    }

    if (to.path === '/home' || to.path === '/home/') {
      next(resolveDefaultAuthorizedPath());
      return;
    }

    if (!hasRoutePermission(to.path)) {
      next(resolveDefaultAuthorizedPath());
      return;
    }

    next();
  }
});

export default router;
